import { useHistory } from 'react-router-dom';

import ErrorContainer from '@/components/error-handling/app-level/ErrorContainer';
import MainRoutes from '@/components/routes';

import { useErrorContext } from '@/context/Error';

import { page } from '@/lib/analytics';
import { supressNoisyLogs } from '@/lib/logging';

import { useSetIsIncomingBreatherUser } from './breather/hooks';

supressNoisyLogs();

export default function App() {
  // TODO
  // When we start to use Next.js error conventions we will
  // need to rethik thi
  const { appError } = useErrorContext();

  // Breather Incoming Session
  useSetIsIncomingBreatherUser();

  // When routes change, call generic analytics pageview function
  const { listen: onRouteChange } = useHistory();

  onRouteChange(page);

  return (
    <>
      {!appError && <MainRoutes />}
      {!!appError && <ErrorContainer />}
    </>
  );
}
